import { render, staticRenderFns } from "./ActionRechazar.vue?vue&type=template&id=6e137078&lang=pug"
import script from "./ActionRechazar.vue?vue&type=script&lang=js"
export * from "./ActionRechazar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports